// angular
import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../app.service';
import { KlenicoMeService } from '../me.service';

@Component({
    selector: 'me-policies',
    templateUrl: './policies.component.html',
    styleUrls: ['./policies.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class MePoliciesComponent implements OnInit {
    data: any;
    url = 'policies/';

    constructor(
        public appService: AppService,
        public translate: TranslateService,
        public route: ActivatedRoute,
        public router: Router,
        public meService: KlenicoMeService
    ) {
       
    }

    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            let name = params.get('name');
            if (name) {
                this.url = 'policies/' + name;
                this.getContent();
            }
        });

        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            this.appService.isLoading = false;
        }, error => {
            this.appService.isLoading = false;
        });
    }
}
